import { Grid } from "@mui/material";
import { PropsWithChildren } from "react";

export function StatSummary({ children }: Readonly<PropsWithChildren<{}>>) {
    return <Grid container direction="row" className="mt-0 my-0">
        {children}
    </Grid>

}